import QRCode from 'qrcode.react';
interface Props
{
    value: any
}

function QRPrint(props: Props)
{
    return <div className="text-center">
        <QRCode value={props.value} size={150} id="qrApp"
        imageSettings={{src:props.value.favicon,height:50,width:50,excavate:true}} />
    </div>
}
export default QRPrint;